// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-draw-ugc-button > div {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
wm-draw-ugc-button > div ion-button {
  --background: white;
  --box-shadow: 0px 6px 14px rgba(0, 0, 0, 0.2);
  height: 40px;
  margin: 0;
}
wm-draw-ugc-button > div > div {
  display: flex;
  gap: 10px;
}
wm-draw-ugc-button > div > div > ion-button {
  flex: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/draw-ugc-button/draw-ugc-button.component.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAJ;AACI;EACE,mBAAA;EACA,6CAAA;EACA,YAAA;EACA,SAAA;AACN;AACI;EACE,aAAA;EACA,SAAA;AACN;AACM;EACE,OAAA;AACR","sourcesContent":["wm-draw-ugc-button {\n  > div {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    ion-button {\n      --background: white;\n      --box-shadow: 0px 6px 14px rgba(0, 0, 0, 0.2);\n      height: 40px;\n      margin: 0;\n    }\n    > div {\n      display: flex;\n      gap: 10px;\n\n      > ion-button {\n        flex: 1;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
